import { useNavigate } from "react-router-dom";
import { AgingChip } from "@/components/AgingChip";
import StageBadge from "@/components/StageBadge";

export default function ReferralTable({ rows = [], testid = "referral-table" }) {
  const navigate = useNavigate();
  return (
    <div className="glass rounded-xl overflow-hidden" data-testid={testid}>
      <div className="overflow-x-auto">
        <table className="w-full text-sm">
          <thead>
            <tr className="text-[11px] uppercase tracking-[0.14em] text-muted-foreground font-mono border-b border-white/8">
              <th className="text-left font-medium px-3 py-2.5">ID</th>
              <th className="text-left font-medium px-2 py-2.5">Pt</th>
              <th className="text-left font-medium px-2 py-2.5">Lane</th>
              <th className="text-left font-medium px-2 py-2.5">Stage</th>
              <th className="text-left font-medium px-2 py-2.5">Aging</th>
              <th className="text-right font-medium px-2 py-2.5">Open</th>
              <th className="text-right font-medium px-2 py-2.5">No-note</th>
              <th className="text-left font-medium px-2 py-2.5">Contact</th>
              <th className="text-left font-medium px-3 py-2.5">Location</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (
              <tr><td colSpan={9} className="px-3 py-10 text-center text-muted-foreground font-mono text-xs">No referrals match.</td></tr>
            )}
            {rows.map((r) => (
              <tr
                key={r.id}
                onClick={() => navigate(`/referrals/${r.id}`)}
                data-testid={`referral-row-${r.id}`}
                className={`row-hover cursor-pointer border-b border-white/5 last:border-0 ${r.cancelled ? "opacity-60" : ""}`}
              >
                <td className="px-3 py-2 font-mono text-cyan-300 whitespace-nowrap">
                  {r.id}
                  {r.cancelled && <span className="ml-1.5 text-[11px] font-mono text-red-400 border border-red-500/40 rounded px-1 align-middle" data-testid={`cancelled-tag-${r.id}`}>CANCELLED</span>}
                </td>
                <td className="px-2 py-2 font-mono font-semibold text-foreground">{r.initials}</td>
                <td className="px-2 py-2 whitespace-nowrap">
                  <span className={r.out_of_summary ? "text-amber-300" : "text-foreground"}>{r.lane}</span>
                  {r.out_of_summary && <span className="ml-1.5 text-[10px] font-mono text-amber-400/80">OOS</span>}
                </td>
                <td className="px-2 py-2">
                  <StageBadge referral={r} />
                </td>
                <td className="px-2 py-2"><AgingChip severity={r.aging.severity} stale={r.aging.stale} compact /></td>
                <td className="px-2 py-2 text-right font-mono tnum text-muted-foreground">{r.aging.is_open ? `${r.aging.business_days_open}d` : "—"}</td>
                <td className="px-2 py-2 text-right font-mono tnum">
                  <span className={r.aging.stale ? "text-slate-300" : "text-muted-foreground"}>{r.aging.is_open ? `${r.aging.calendar_days_since_note}d` : "—"}</span>
                </td>
                <td className="px-2 py-2 whitespace-nowrap">
                  {r.receiving_contact || <span className="text-amber-400 font-mono text-xs">{r.lane_contacts?.length ? `UNCLAIMED · LANE (${r.lane_contacts.length})` : "UNASSIGNED"}</span>}
                </td>
                <td className="px-3 py-2 text-muted-foreground whitespace-nowrap">{r.location}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
